/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_GameInputs */

const th_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดดูเกม →`)
};

const en_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open game →`)
};

const ja_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試合を開く →`)
};

const zh_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开比赛 →`)
};

const es_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir partido →`)
};

const pt_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir jogo →`)
};

const id_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka pertandingan →`)
};

const fr_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le match →`)
};

const tl_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buksan ang laro →`)
};

const vi_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở trận →`)
};

const ko_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기 열기 →`)
};

const de_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiel öffnen →`)
};

const ru_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть матч →`)
};

const tr_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maçı aç →`)
};

const it_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri la partita →`)
};

const pl_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz mecz →`)
};

const uk_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відкрити матч →`)
};

const hi_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैच खोलें →`)
};

const ar_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتح المباراة ←`)
};

const ms_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka perlawanan →`)
};

const bn_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খেলা খুলুন →`)
};

const zh_tw2_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟比賽 →`)
};

const zh_hk2_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟比賽 →`)
};

const ur_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`میچ کھولیں ←`)
};

const fa_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`باز کردن بازی ←`)
};

const sw_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fungua mchezo →`)
};

const nl_open_game = /** @type {(inputs: Open_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedstrijd openen →`)
};

/**
* | output |
* | --- |
* | "Open game →" |
*
* @param {Open_GameInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const open_game = /** @type {((inputs?: Open_GameInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_GameInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_open_game(inputs)
	if (locale === "ja") return ja_open_game(inputs)
	if (locale === "zh") return zh_open_game(inputs)
	if (locale === "es") return es_open_game(inputs)
	if (locale === "pt") return pt_open_game(inputs)
	if (locale === "id") return id_open_game(inputs)
	if (locale === "fr") return fr_open_game(inputs)
	if (locale === "tl") return tl_open_game(inputs)
	if (locale === "vi") return vi_open_game(inputs)
	if (locale === "ko") return ko_open_game(inputs)
	if (locale === "de") return de_open_game(inputs)
	if (locale === "ru") return ru_open_game(inputs)
	if (locale === "tr") return tr_open_game(inputs)
	if (locale === "it") return it_open_game(inputs)
	if (locale === "pl") return pl_open_game(inputs)
	if (locale === "uk") return uk_open_game(inputs)
	if (locale === "hi") return hi_open_game(inputs)
	if (locale === "ar") return ar_open_game(inputs)
	if (locale === "ms") return ms_open_game(inputs)
	if (locale === "bn") return bn_open_game(inputs)
	if (locale === "zh-TW") return zh_tw2_open_game(inputs)
	if (locale === "zh-HK") return zh_hk2_open_game(inputs)
	if (locale === "ur") return ur_open_game(inputs)
	if (locale === "fa") return fa_open_game(inputs)
	if (locale === "sw") return sw_open_game(inputs)
	if (locale === "nl") return nl_open_game(inputs)
	return en_open_game(inputs)
});